module.exports = __webpack_public_path__ + "img/kherson_energo.3581d1a4.png";